export default {"src":"/_next/static/media/AboutUsMobileVector.d0affb22.svg","height":258,"width":318,"blurWidth":0,"blurHeight":0};